import React from 'react';
import { Message } from 'semantic-ui-react';

// Global Components
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import ErrorValue from 'components/ErrorValue';
// @ts-ignore
import ErrorGate from 'components/ErrorGate';
import NestedErrorsExistGate from 'components/NestedErrorsExistGate';
import NestedErrorUuids from 'components/NestedErrorUuids';

// Local Components
import MyTimesheetEntriesErrorMessageListItem from './components/MyTimesheetEntriesErrorMessageListItem';

// Local Constants
import { REQUEST_NAMESPACE } from '../../constants';

const MyTimesheetEntriesErrorMessage = (): React.ReactElement => (
    <ErrorBoundary
        namespace="MyTimesheetEntriesErrorMessage"
        FallbackComponent={<ErrorBoundaryAlert />}
    >
        <ErrorGate
            namespace={REQUEST_NAMESPACE}
            FallbackComponent={
                <Message negative>
                    <NestedErrorsExistGate
                        namespace={REQUEST_NAMESPACE}
                        FallbackComponent={
                            <React.Fragment>
                                <Message.Header>
                                    Your changes could not be saved.
                                </Message.Header>
                                <p>
                                    <ErrorValue namespace={REQUEST_NAMESPACE} />
                                </p>
                            </React.Fragment>
                        }
                    >
                        <Message.Header>
                            There were issues that prevented your changes from
                            being saved.
                        </Message.Header>
                        <Message.List>
                            <NestedErrorUuids
                                namespace={REQUEST_NAMESPACE}
                                component={
                                    MyTimesheetEntriesErrorMessageListItem
                                }
                            />
                        </Message.List>
                    </NestedErrorsExistGate>
                </Message>
            }
        >
            {''}
        </ErrorGate>
    </ErrorBoundary>
);

export default MyTimesheetEntriesErrorMessage;
